"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Password = _interopRequireDefault(require("../screens/Password"));
var _resetPassword = _interopRequireDefault(require("../../mutations/resetPassword"));
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _ApiErrors = require("../../../../records/ApiErrors");
var _context = require("../../../../services/log/context");
var _context2 = require("../../../../services/auth/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const validateRequiredField = value => !value ? _errors.default.requiredField : null;
class KiwiLoginWithoutContext extends React.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      error: null,
      password: "",
      isPasswordVisible: false,
      isSigningIn: false
    });
    (0, _defineProperty2.default)(this, "handleSignIn", e => {
      const {
        email,
        onSignIn,
        onFulfill,
        log
      } = this.props;
      const {
        password
      } = this.state;
      e.preventDefault();
      if (this.validateInput()) {
        return;
      }
      this.setState({
        isSigningIn: true,
        error: null
      });
      onSignIn(email, password).then(() => {
        this.setState({
          isSigningIn: false
        });
        log(_events.LOGGED_WITH_ACCOUNT, {
          email
        });
        onFulfill();
      }).catch(err => {
        var _error$message;
        const error = _ApiErrors.KNOWN_ERRORS[err === null || err === void 0 ? void 0 : err.message];
        switch (error === null || error === void 0 ? void 0 : error.code) {
          case "NOT_VERIFIED":
            log(_events.SIGN_IN_NOT_VERIFIED, {});
            break;
          case "BLOCKED_TEMPORARILY":
            log(_events.SIGN_IN_BLOCKED_TEMPORARILY, {});
            break;
          case "INVALID_LOGIN":
            log(_events.SIGN_IN_INVALID_LOGIN, {});
            break;
          default:
            log(_events.LOGIN_STEP_FAILED, {
              operation: "onSignIn",
              error: String(err)
            });
            break;
        }
        this.setState({
          error: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : _errors.default.general,
          isSigningIn: false
        });
      });
    });
    (0, _defineProperty2.default)(this, "handleChangeEmail", () => {
      const {
        onChangeScreen,
        log
      } = this.props;
      log(_events.CHANGE_EMAIL, {});
      onChangeScreen("emailLogin");
    });
    (0, _defineProperty2.default)(this, "handlePasswordChange", value => {
      this.setState({
        password: value
      });
    });
    (0, _defineProperty2.default)(this, "handleTogglePasswordVisibility", () => {
      this.setState(prevState => ({
        isPasswordVisible: !prevState.isPasswordVisible
      }));
    });
    (0, _defineProperty2.default)(this, "handleForgotPassword", () => {
      const {
        email,
        brandId,
        onChangeScreen,
        log
      } = this.props;
      this.setState({
        error: null
      });
      log(_events.RESET_PASSWORD_REQUESTED, {});
      (0, _resetPassword.default)({
        email,
        brandId
      }).then(res => {
        if ("error" in res) {
          const isNotVerified = res.error === "NOT_VERIFIED";
          const error = isNotVerified ? _errors.default.notVerified : _errors.default.general;
          if (!isNotVerified) {
            log(_events.RESET_PASSWORD_NOT_VERIFIED, {});
          } else {
            log(_events.LOGIN_STEP_FAILED, {
              operation: "resetPassword"
            });
          }
          this.setState({
            error
          });
          return;
        }
        onChangeScreen("resetPassword");
      }).catch(err => {
        log(_events.CRITICAL_LOGIN_ERROR, {
          error: String(err),
          operation: "resetPassword"
        });
        this.setState({
          error: _errors.default.general
        });
      });
    });
    (0, _defineProperty2.default)(this, "validateInput", () => {
      const {
        password
      } = this.state;
      const errorMessage = validateRequiredField(password);
      const hasError = typeof errorMessage === "string";
      if (hasError) {
        this.setState({
          error: errorMessage
        });
      }
      return hasError;
    });
  }
  render() {
    const {
      email,
      canChangeEmail
    } = this.props;
    const {
      error,
      password,
      isPasswordVisible,
      isSigningIn
    } = this.state;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Password.default, {
      email: email,
      canChangeEmail: canChangeEmail,
      error: error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          ...error
        })
      }),
      isSigningIn: isSigningIn,
      password: password,
      validator: validateRequiredField,
      isPasswordVisible: isPasswordVisible,
      onChangeEmail: this.handleChangeEmail,
      onForgotPassword: this.handleForgotPassword,
      onPasswordChange: this.handlePasswordChange,
      onTogglePasswordVisibility: this.handleTogglePasswordVisibility,
      onSignIn: this.handleSignIn
    });
  }
}
const KiwiLogin = props => {
  const {
    log
  } = (0, _context.useLog)();
  const {
    onSignIn
  } = (0, _context2.useAuth)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(KiwiLoginWithoutContext, {
    ...props,
    log: log,
    onSignIn: onSignIn
  });
};
var _default = KiwiLogin;
exports.default = _default;